var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1793_4096",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1793_4096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.45843 12.498L3.71875 11.7583L10.6891 4.78125H4.35218V3.71875H12.498V11.8646H11.4355V5.52766L4.45843 12.498Z",
    fill: "#007EFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkArrow);
export default __webpack_public_path__ + "static/media/ExternalLinkArrow.ad90cc4afcbeba2273bbeb73a32e80d1.svg";
export { ForwardRef as ReactComponent };